// removed by extract-text-webpack-plugin
module.exports = {"bg":"_28Ey9","base":"_2EFt5","sectionHeader":"_3jbrQ","title":"shFSl","content":"_2_-iK","spinner":"Mw6Tg","list":"_3zeo0","fieldset":"_1cCkk","form":"_3pSsB","group":"_3V2RQ","formNoMarginTop":"_3G0ik","footer":"_1VNXL"};


//////////////////
// WEBPACK FOOTER
// ./src/views/PartnerPlans/PartnerPlanDisplayForm.scss
// module id = 177
// module chunks = 0